import type { FlexProps } from '@chakra-ui/react';
import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { MaskIcon } from '@ui/components/MaskIcon';
import type { ExtendedTokenInfo } from '@ui/views/card-cronos/core/types';
import { type ReactNode } from 'react';

export const TokenSelector = ({
  token,
  footer,
  ...props
}: FlexProps & {
  token: ExtendedTokenInfo;
  footer?: ReactNode;
}) => {
  return (
    <Flex
      flex="1"
      justify="center"
      alignItems="center"
      bg="gradients.sky-blue-20"
      borderWidth="1px"
      borderColor="brand.gray-scale-border-20"
      py="16px"
      cursor={props.onClick ? 'pointer' : undefined}
      roundedRight="8px"
      {...props}
      sx={{
        '.cronos-display-card--error &': {
          borderTopColor: 'brand.error',
          borderBottomColor: 'brand.error',
          borderRightColor: 'brand.error',
        },
        ...props.sx,
      }}
    >
      <VStack gap="4px">
        <HStack alignItems="center" gap="8px">
          {token.Icon && (
            <token.Icon
              boxSize={{
                base: '16px',
                desktop: '24px',
              }}
            />
          )}
          <Text
            textStyle={{
              base: 'body2Bold',
              desktop: 'subtitle3',
            }}
          >
            {token.symbol}
          </Text>
          {!!props.onClick && (
            <MaskIcon
              icon={`url(${getAssetUrl('/masks/down-arrow.svg')})`}
              bg="brand.white"
              boxSize={{
                base: '16px',
                desktop: '24px',
              }}
            />
          )}
        </HStack>
        {footer && (
          <Box
            textStyle="caption"
            _firstLetter={{
              textTransform: 'capitalize',
            }}
          >
            {footer}
          </Box>
        )}
      </VStack>
    </Flex>
  );
};
